import React, { memo } from 'react'

import { func } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

import ProgressBar from '../ProgressBar/ProgressBar'
import UpgradeCard from '../UpgradeCard/UpgradeCard'

const ALMOST_OUT_THRESHOLD = 0.8

function FreeBetaBody({ onClose: handleClose }) {
  const t = useTranslation()
  const monthlyUsed = useThreeDStudioStore(state => state.subscription.monthlyGenerationsUsed)
  const monthlyAvailable = useThreeDStudioStore(state => state.subscription.monthlyGenerationsAvailable)

  const usageRatio = monthlyAvailable > 0 ? monthlyUsed / monthlyAvailable : 0
  let headline = null
  if (usageRatio >= 1) {
    headline = t('usageModal.freeBeta.outOfGenerations')
  } else if (usageRatio >= ALMOST_OUT_THRESHOLD) {
    headline = t('usageModal.freeBeta.almostOutOfGenerations')
  }

  return (
    <div className="usage-modal__free-beta">
      {headline && (
        <p className="usage-modal__warning-headline cgt-heading-200">
          {headline}
        </p>
      )}

      <ProgressBar
        label={t('usageModal.freeBeta.generationsUsedLabel')}
        used={monthlyUsed}
        total={monthlyAvailable}
        tooltip={t('usageModal.subscribed.generationsRatioTooltip')}
        tooltipId="usage-modal-free-beta-generations"
      />

      <UpgradeCard onClose={handleClose} />
    </div>
  )
}

FreeBetaBody.propTypes = {
  onClose: func.isRequired,
}

export default memo(FreeBetaBody)
